import React from "react";
import ReactDOM from 'react-dom';
import { rootModuleId } from "@app/const";
import { DesignClass } from "@app/types";
import NodeRegistry from "@app/utilities/NodeRegistry";
import { ReactDOMComponents } from "@app/utilities/ReactDOMComponents";
import Utility from "@app/utilities/Utility";
import PropertyPanelWidget from "./PropertyPanelWidget";

export default class IntentsWidget extends React.Component {
    /**
     * Intents page
     * @module IntentsWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
  
        this.reactDOMComponents = new ReactDOMComponents();
        this.handleTransitionPanel = this.handleTransitionPanel.bind(this);
        this.handleComponentPanel = this.handleComponentPanel.bind(this);
        this.handleGlobalModulePanel = this.handleGlobalModulePanel.bind(this);
        this.handleMousedown = this.handleMousedown.bind(this);
    }

    componentDidMount(){
        document.addEventListener('intents-transition-property-panel', this.handleTransitionPanel);
        document.addEventListener('intents-component-property-panel', this.handleComponentPanel);
        document.addEventListener('intents-globalModule-property-panel', this.handleGlobalModulePanel);
        document.addEventListener('mousedown', this.handleMousedown);
    }

    componentWillUnmount(){
        document.removeEventListener('intents-transition-property-panel', this.handleTransitionPanel);
        document.removeEventListener('intents-component-property-panel', this.handleComponentPanel);
        document.removeEventListener('intents-globalModule-property-panel', this.handleGlobalModulePanel);
        document.removeEventListener('mousedown', this.handleMousedown);
    }

    handleMousedown(e){
        if(e.target.parentElement.className === 'nav-button' || e.target.className === 'nav-button'){
            this.hidePropertyPanel();
        }
        
    }

    hidePropertyPanel() {
        Utility.hidePropertyPanel();
    }

    handleTransitionPanel(event){
        //this.hidePropertyPanel();
        var linkProperties = window.apm.serialized.globalIntents.findIndex(intent => intent.id === event.detail.event.id);
        var proxyNode;
        proxyNode = new NodeRegistry.r[window.apm.serialized.globalIntents[linkProperties].conditionProperties["_class"]](window.apm.serialized.globalIntents[linkProperties].conditionProperties.props.config.name, 0, 0, window.apm.serialized.globalIntents[linkProperties].conditionProperties.props, window.apm.serialized.globalIntents[linkProperties].conditionProperties.id);
        this.showPropertyPanel(proxyNode, null, event.detail.event.toolBarNode);
    }

    handleComponentPanel(event){
        //this.hidePropertyPanel();
        var node;
        if (event.detail) {
            node = window.apm.getNode(event.detail.event.id);
        } else {
            node = window.apm.serialized.components.modules.find(mod => mod.id === rootModuleId)
        }
        var proxyNode;
        if (node.type === "variable") {
            proxyNode = new VariableDataModel(node.props, node.id);
        } else {
            proxyNode = new NodeRegistry.r[node["_class"]](node.name, 0, 0, node.props, node.id);
            if (node._class === DesignClass.module) {
                proxyNode.setProperty("ref", node.id);
            }
            proxyNode.setProperty("parentComponentID", node.id);
        }
        proxyNode.setWriteProxy((key, value) => {
            const nodeCopy = JSON.parse(JSON.stringify(node));
            nodeCopy.name = proxyNode.getConfig("name");
            nodeCopy.props = proxyNode.serialize().props;
            window.apm.setNode(nodeCopy.id, nodeCopy);

            window.apm.postEventToAllViews({ target: "request-update-evaluation" });

            try {
                if (treeL) {
                    treeL.jstree().rename_node(node.id, proxyNode.getConfig("name"));
                    // treeL.jstree().get_node(node.id).props = node.props;
                }
            } catch (err) {
                console.warn(err);
            }
        });
        if(!event.suppressPropertyPanel){
            this.showPropertyPanel(proxyNode, null, event.toolBarNode);
        }
    }

    handleGlobalModulePanel(event){
        //this.hidePropertyPanel();
        
        if(event.detail.event.node[" _class"]){
            event.detail.event.node["_class"] = event.detail.event.node[" _class"];
            delete event.detail.event.node[" _class"];
        }

        if(event.detail.event.node[" type"]){
            event.detail.event.node["type"] = event.detail.event.node[" type"];
            delete event.detail.event.node[" type"];
        }

        var proxyNode = new NodeRegistry.r[event.detail.event.node["_class"]](event.detail.event.node.name, 0, 0, event.detail.event.node.props, event.detail.event.node.id);
        proxyNode.intent = event.detail.event.intent;

        this.showPropertyPanel(proxyNode, null, event.detail.toolBarNode);
    }

     /**
     * Show property panel for a given node
     * @param {Object} model Node or link model
     * @param {number} eventX Mouse click event x coordinate
     */
    showPropertyPanel(model, eventX = null, toolBarNode = false) {
        const panel = $("#property_panel");
        const node = window.apm.getNode(rootModuleId);
        const displayClass = (model.hasWriteProxy && model.hasWriteProxy()) ? "app-component" : ''; 
        const canvasWidth = window.innerWidth;
        ReactDOM.render(
            <PropertyPanelWidget 
                context={model}
                panelDOM={panel}
                displayClass={displayClass}
                embed={false} 
                node={node}
                eventX={eventX}
                canvasWidth={canvasWidth}
                toolBarNode={toolBarNode}
                closeOnClickOutside={true}
                onClose={this.unselectAllIntents}
                excludeOnClickOutside={[document.querySelector('.tag-items')]}
            />,
            panel.get(0)
        );
    }

    unselectAllIntents(){
        document.querySelectorAll('.intent-row.selected').forEach(intent => {
            intent.classList.remove('selected');
        }); 
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div className="container-fluid" onClick={() => this.unselectAllIntents()}>
                {this.props.children}
            </div>
        );
    }
}
